import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DataroomNode } from '@core/models/dataroom-node.model';

import { DataroomBrowserComponent } from '../dataroom-browser/dataroom-browser.component';
import { TypedFormGroup } from '@feature/forms/form-model';

@Component({
    selector: 'wai-dataroom-browser-breadcrumbs',
    templateUrl: './dataroom-browser-breadcrumbs.component.html',
    styleUrls: ['./dataroom-browser-breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DataroomBrowserBreadcrumbsComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;
  public asDataroomNode = (x: unknown): DataroomNode => x as DataroomNode;

  @Input() public dataroomBrowser: DataroomBrowserComponent;
}
